import { render } from "./FilterProductUom.vue?vue&type=template&id=bce48cdc"
import script from "./FilterProductUom.vue?vue&type=script&lang=js"
export * from "./FilterProductUom.vue?vue&type=script&lang=js"
script.render = render

export default script